export const Separator = () => (
    <hr className="my-4 border-gray-200" />
  );
  